import { DetailedShipList } from '@ais-ui/api-spec/config';

interface ShiplistTarget {
  name?: string;
  mmsi?: string;
  imo?: string;
}

/**
 * Build a DetailedShipList from a name and array of targets.
 * Shared between TargetsOnMap (main window) and popup shiplist creation
 * to keep MMSI/IMO validation in one place.
 */
export const buildShiplistFromTargets = (
  name: string,
  targets: ShiplistTarget[],
): DetailedShipList => ({
  name,
  max: 0,
  color: '003b5c',
  acl: [],
  id: '',
  ships: targets.map((target) => ({
    name: target?.name ?? '',
    // MMSI must be a valid 9-digit number (001234567 will otherwise cause an error)
    mmsi:
      target?.mmsi &&
      Number(target.mmsi) > 0 &&
      String(Number(target.mmsi)).length === 9
        ? Number(target.mmsi)
        : -1,
    imo:
      target?.imo && /^\d{7}$/.test(target.imo)
        ? Number(target.imo)
        : undefined,
  })),
});
